/*
 * @Author:
 * @Description:
 * @Date: 2024-09-13 20:58:27
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/views/register/mixins/index.js
 */

import { REQUIRED } from '@/components/validation/tool/validator';
import { uploadMaterialUseTemplate } from '@/views/transfer/api/contact';

import { getMerchantInfo } from '../api/index';
export default {
  data() {
    return {
      loading: false,
      // isDisabled: false,
      applicationInfo: {
        currentStep: 'businessType',
        businessType: {
          businessLocation: '', // 公司所在地
          typeOfBusiness: '', // 公司类型
        },
        businessDetails: {
          legalBusinessName: '',
          companyRegistrationNumber: '',
          companyRegistrationDate: '',
          businessName: '',
          businessPhoneNumber: '',
          registeredBusinessAddress: {
            location: '',
            areaOrCity: '',
            district: '',
            addressLine1: '',
            addressLine2: '',
            postalCode: '',
          },
          uploadCompanyCertificates: {
            certificateOfIncorporation: '', // 公司注册证书
            businessRegistrationCertificate: '', // 公司营业登记证书
            companyNnc1OrNar1: '', // 公司NNC1/NAR1
            explanationOfShareholdingStructure: '', // 股权结构说明
            articlesOfAssociation: '', // 公司章程
            extraDocument1: '', // 补充资料1
            extraDocument2: '', // 补充资料2
            extraDocument3: '', // 补充资料3
          },
        },
        businessRepresentative: {
          legalName: {
            firstName: '',
            lastName: '',
          },
          emailAddress: '',
          jobTitle: '',
          dateOfBirth: '',
          homeAddress: {
            location: '',
            areaOrCity: '',
            district: '',
            addressLine1: '',
            addressLine2: '',
            postalCode: '',
          },
          phoneNumber: '',
          personalIdNumber: '',
          uploadPersonalIdImages: {
            id: '',
            passport: '',
          },
        },
        businessOwners: {
          legalName: {
            firstName: '',
            lastName: '',
          },
          emailAddress: '',
        },
        websiteOrAppDetails: {
          businessWebsite: '',
          durationOfOperation: '',
          businessWebsiteType: '',
          websiteDefaultDomain: '',
          industryOrBusinessCategory: '',
          monthlyTradingVolumeUsd: '',
          monthlyDisputeRate: '',
          monthlyRefundRate: '',
          market: '',
          uploadBusinessProofs: {
            transactionStatementsLastThreeMonths: '',
            screenshotsOfBusinessPlatforms: '',
          },
        },
        bankAccount: {
          accountHolderName: '',
          depositBank: '',
          depositBranch: '',
          currency: '',
          accountNumber: '',
          confirmAccountNumber: '',
          uploadBankStatement: '',
          uploadExtraProofs: {
            extraDocument1: '',
            extraDocument2: '',
            extraDocument3: '',
            extraDocument4: '',
            extraDocument5: '',
          },
        },
      },
      defaultObj: {
        currentStep: 'businessType',
        businessType: {
          businessLocation: '', // 公司所在地
          typeOfBusiness: '', // 公司类型
        },
        businessDetails: {
          legalBusinessName: '',
          companyRegistrationNumber: '',
          companyRegistrationDate: '',
          businessName: '',
          businessPhoneNumber: '',
          registeredBusinessAddress: {
            location: '',
            areaOrCity: '',
            district: '',
            addressLine1: '',
            addressLine2: '',
            postalCode: '',
          },
          uploadCompanyCertificates: {
            certificateOfIncorporation: '', // 公司注册证书
            businessRegistrationCertificate: '', // 公司营业登记证书
            companyNnc1OrNar1: '', // 公司NNC1/NAR1
            explanationOfShareholdingStructure: '', // 股权结构说明
            articlesOfAssociation: '', // 公司章程
            extraDocument1: '', // 补充资料1
            extraDocument2: '', // 补充资料2
            extraDocument3: '', // 补充资料3
          },
        },
        businessRepresentative: {
          legalName: {
            firstName: '',
            lastName: '',
          },
          emailAddress: '',
          jobTitle: '',
          dateOfBirth: '',
          homeAddress: {
            location: '',
            areaOrCity: '',
            district: '',
            addressLine1: '',
            addressLine2: '',
            postalCode: '',
          },
          phoneNumber: '',
          personalIdNumber: '',
          uploadPersonalIdImages: {
            id: '',
            passport: '',
          },
        },
        businessOwners: {
          legalName: {
            firstName: '',
            lastName: '',
          },
          emailAddress: '',
        },
        websiteOrAppDetails: {
          businessWebsite: '',
          durationOfOperation: '',
          businessWebsiteType: '',
          websiteDefaultDomain: '',
          industryOrBusinessCategory: '',
          monthlyTradingVolumeUsd: '',
          monthlyDisputeRate: '',
          monthlyRefundRate: '',
          market: '',
          uploadBusinessProofs: {
            transactionStatementsLastThreeMonths: '',
            screenshotsOfBusinessPlatforms: '',
          },
        },
        bankAccount: {
          accountHolderName: '',
          depositBank: '',
          depositBranch: '',
          currency: '',
          accountNumber: '',
          confirmAccountNumber: '',
          uploadBankStatement: '',
          uploadExtraProofs: {
            extraDocument1: '',
            extraDocument2: '',
            extraDocument3: '',
            extraDocument4: '',
            extraDocument5: '',
          },
        },
      },
    };
  },
  mounted() {
    this.queryMerchantInfo();
  },
  methods: {
    async queryMerchantInfo() {
      try {
        const res = await getMerchantInfo();
        this.applicationInfo = {};
        if (res) {
          this.applicationInfo = Object.assign(this.applicationInfo, res);
        } else {
          this.applicationInfo = Object.assign(this.defaultObj, this.applicationInfo);
        }
      } catch (err) {
      } finally {
      }
    },
    validateAsync() {
      return this.$refs.validationForm.validateAsync();
    },
    slotValueChange(value, key) {
      this.$refs.validationForm.setItemValue(key, value);
    },
    onMaterialItemChange(form, objKey, fileListName) {
      return async (event) => {
        this.dataLoading = true;
        try {
          const res = await uploadMaterialUseTemplate(event.raw);
          this.$refs.validationForm.setItemValue(fileListName, res);
          this[form][`${objKey}`][fileListName] = res;
          this[form][`${objKey}`].fileList[fileListName] = [{
            name: event.name,
            url: res,
          }];
          if (objKey === 'uploadPersonalIdImages' && fileListName === 'id') {
            if (this[form][`${objKey}`][fileListName]) {
              this.$refs.validationForm.updateItemRule('passport', []);
            }
          }
          if (objKey === 'uploadPersonalIdImages' && fileListName === 'passport') {
            if (this[form][`${objKey}`][fileListName]) {
              this.$refs.validationForm.updateItemRule('id', []);
            }
          }
          this.$refs.validationForm.clearValidate(fileListName);
          ;
        } catch (err) {
        }
        this.dataLoading = false;
      };
    },
    onMaterialItemRemove(form, objKey, fileListName) {
      return async () => {
        this.$refs.validationForm.setItemValue(fileListName, '');
        this[form][`${objKey}`][fileListName] = '';
        this[form][`${objKey}`].fileList[fileListName] = [];
        if (objKey === 'uploadPersonalIdImages' && fileListName === 'id') {
          if (this[form].uploadPersonalIdImages.passport) {
            this.$refs.validationForm.updateItemRule('id', []);
            this.$refs.validationForm.updateItemRule('passport', [REQUIRED]);
          } else {
            this.$refs.validationForm.updateItemRule('id', [REQUIRED]);
            this.$refs.validationForm.updateItemRule('passport', [REQUIRED]);
          }
        }
        if (objKey === 'uploadPersonalIdImages' && fileListName === 'passport') {
          if (this[form].uploadPersonalIdImages.id) {
            this.$refs.validationForm.updateItemRule('passport', []);
            this.$refs.validationForm.updateItemRule('id', [REQUIRED]);
          } else {
            this.$refs.validationForm.updateItemRule('id', [REQUIRED]);
            this.$refs.validationForm.updateItemRule('passport', [REQUIRED]);
          }
        }
      };
    },

  },
  computed: {
    isDisabled() {
      return this.applicationInfo.currentStep === 'status';
    },
  },
};
